import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarUnit = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.504 10.374a.75.75 0 0 1 .75.75v1.752a.75.75 0 0 1-1.5 0v-1.752a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.5 3.541a1.916 1.916 0 0 0-2.306 1.875v13.168A1.916 1.916 0 0 0 12.5 20.46l5.223-1.084A1.915 1.915 0 0 0 19.25 17.5v-11c0-.907-.637-1.69-1.527-1.875zM8.694 5.416a3.416 3.416 0 0 1 4.111-3.344l5.223 1.084A3.415 3.415 0 0 1 20.75 6.5v11a3.415 3.415 0 0 1-2.722 3.344l-5.223 1.084a3.416 3.416 0 0 1-4.111-3.344z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.25 7.327a3.2 3.2 0 0 1 3.203-3.202h2.852a.75.75 0 0 1 0 1.5H6.453c-.94 0-1.703.763-1.703 1.702v9.346c0 .94.762 1.702 1.703 1.702h2.852a.75.75 0 0 1 0 1.5H6.453a3.2 3.2 0 0 1-3.203-3.202z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarUnit);
export default ForwardRef;
